import Tag from "components/ui/Tag/Tag";
import styles from "./CategoryTags.module.scss";

export default function CategoryTags({ categories }) {
  return (
    <div className={`${styles.categoryTags}`}>
      {categories?.map((item) => (
        <Tag key={`category-${item.id}`} textTransform={false}>
          {"#" + item.category_name}
        </Tag>
      ))}
    </div>
  );
}
